import React, { FC } from 'react';
import styles from './RemoveBadge.module.scss';
import clsx from 'clsx';
import RemoveBadgeIcon from 'assets/icons/remove-badge.svg?react';
import { PermissionGate } from 'helpers/projectPermissions/PermissionGate.tsx';
import { permission } from 'helpers/projectPermissions/types/projectPermission.ts';
import {
  OperationType,
  ProjectResourceType,
} from 'services/api/api-client.types.ts';

export type RemoveBadgeProps = {
  enabled: boolean;
  children: string | React.JSX.Element;
  className?: string;
  position: { top?: number; left?: number };
  onClick: () => void;
};

export const RemoveBadge: FC<RemoveBadgeProps> = (props) => {
  return (
    <div className={clsx(props.className, styles.wrapper)}>
      {props.children}
      {props.enabled && (
        <PermissionGate
          permissions={[
            permission(ProjectResourceType.ProjectRole, OperationType.Update),
            permission(ProjectResourceType.Document, OperationType.Update),
          ]}
        >
          <div
            className={styles.badge}
            style={{
              top: props.position.top ?? 0 + 'px',
              left: props.position.left ?? 0 + 'px',
            }}
            onClick={props.onClick}
          >
            <RemoveBadgeIcon className={styles.icon} />
          </div>
        </PermissionGate>
      )}
    </div>
  );
};
